export const volumesOptions = [
  { value: 0.75, label: "0.75 L" },
  { value: 1.5, label: "1.5 L" },
  { value: 3, label: "3 L" },
  { value: 4.5, label: "4,5 L" },
  { value: 6, label: "6 L" },
  { value: 9, label: "9 L" },
  { value: 12, label: "12 L" },
  { value: 15, label: "15 L" },
];

export const volumesOptionsCola = [{ value: 0.7, label: "0.7 L" }, ...volumesOptions];

// Woodbox do not exist for every bottle volume
export const volumesOptionsWoodBox = [
  { value: 0.75, label: "0,75 L" },
  { value: 1.5, label: "1,5 L" },
  { value: 3, label: "3 L" },
  { value: 6, label: "6 L" },
  { value: 9, label: "9 L" },
];

// For a given bottle volume, return the available bottles quantity for woodbox
export const VolumesWoodBoxAvailable = [
  { value: 0.75, available: [1, 3, 6, 12] },
  { value: 1.5, available: [1, 3, 6] },
  { value: 3, available: [1] },
  { value: 6, available: [1] },
];
